import React, {useEffect, useState} from "react"
import {Col, Form, Row} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import {notification} from "antd";
import SelectField from "../../../components/common/select-field/SelectField";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import DescriptionField from "../../../components/common/description-field/DescriptionField";
import {CloseRoundedCheck, RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import {AddMonthTargets} from "../../../services/target-api.service";
import {getMonthName} from "../../../utils/helper";

export default function AddMonthlyTargets({close, getListing, setGetListing, goalSelectedCategroy, setGoalSelectedCategory, selectedCategory,year, selectedMonth ,defaultSelectedQuarter, duplicateData }) {    const[loader,setLoader] = useState(false);
    const[question,setQuestion] = useState(false);
    const [monthOptions, setMonthOptions] = useState([]);
    
    console.log('AddMonthlyTargets received duplicateData:', duplicateData);
    
    const {
        handleSubmit,
        reset,
        formState: {errors, isValid},
        control,
        setValue,
        watch
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            quater: duplicateData?.quarter || defaultSelectedQuarter || '',
            month: duplicateData?.month || selectedMonth || '',
            des: duplicateData?.title || '',
            category: duplicateData?.category || ''
        }
    })
    const navigate = useNavigate()

    const questionPayload = {
        category: 'gratitude',
    }

    const quarterMonths = {
        "1": [
            { value: "1", label: "January" },
            { value: "2", label: "February" },
            { value: "3", label: "March" }
        ],
        "2": [
            { value: "4", label: "April" },
            { value: "5", label: "May" },
            { value: "6", label: "June" }
        ],
        "3": [
            { value: "7", label: "July" },
            { value: "8", label: "August" },
            { value: "9", label: "September" }
        ],
        "4": [
            { value: "10", label: "October" },
            { value: "11", label: "November" },
            { value: "12", label: "December" }
        ]
    };


    const quarterSelect = [
        { value: "1", label: "Quarter 1" },
        { value: "2", label: "Quarter 2" },
        { value: "3", label: "Quarter 3" },
        { value: "4", label: "Quarter 4" }
    ];


    const onSubmit = async (data) => {
        let payload = {
            quarter:parseInt(data.quater),
            month: parseInt(data.month),
            year:year,
            title:data.des,
            category: selectedCategory === "" ? data.category : selectedCategory,
            typeValue: getMonthName(parseInt(data.month))
        }
        console.log(payload, 'data month')
        setLoader(true)

        if(data){

            const response = await AddMonthTargets(payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: "Monthly Target added Successfully",
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setLoader(false)
                reset()
                setGetListing(prevState => !prevState);
                close(false)
            }
            else{
                setLoader(false)
                notification.error({
                    message: "Failed",
                    description: "Monthly Target Failed to Add",
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            }

        }

    }

    const categorySelect = [
        { value: "Faith", label: "Faith" },
        { value: "Family", label: "Family" },
        { value: "Fitness", label: "Fitness" },
        { value: "Finance", label: "Finance" }
    ];

    const selectedQuarter = watch("quater");
    const hasMounted = React.useRef(false);

    useEffect(() => {
        const monthsForQuarter = quarterMonths[selectedQuarter] || [];
        setMonthOptions(monthsForQuarter);

        // 🛑 Skip resetting month on first mount to preserve selectedMonth from props
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }

        // ✅ On quarter change (after initial mount), reset the month to the first in the list
        if (monthsForQuarter.length > 0) {
            setValue("month", monthsForQuarter[0].value, { shouldValidate: true });
        } else {
            setValue("month", "", { shouldValidate: true });
        }
    }, [selectedQuarter, setValue]);

    useEffect(() => {
        if (defaultSelectedQuarter) {
            setValue("quater", defaultSelectedQuarter);
            const monthsForQuarter = quarterMonths[defaultSelectedQuarter] || [];
            setMonthOptions(monthsForQuarter);
            if (monthsForQuarter.length > 0) {
                setValue("month", selectedMonth || monthsForQuarter[0].value);
            }
        }
    }, [defaultSelectedQuarter, selectedMonth, setValue]);

    // Handle duplicate data population
    useEffect(() => {
        if (duplicateData) {
            console.log('Processing duplicate data in monthly targets:', duplicateData);
            if (duplicateData.quarter) {
                setValue("quater", duplicateData.quarter.toString());
                const monthsForQuarter = quarterMonths[duplicateData.quarter.toString()] || [];
                setMonthOptions(monthsForQuarter);
            }
            if (duplicateData.month) {
                setValue("month", duplicateData.month.toString());
            }
            if (duplicateData.title) {
                console.log('Setting monthly title:', duplicateData.title);
                setValue("des", duplicateData.title);
            }
            if (duplicateData.category) {
                console.log('Setting monthly category:', duplicateData.category);
                setValue("category", duplicateData.category);
            }
        }
    }, [duplicateData, setValue]);


    return(
        <div className={'add-gratitude'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md={6}>
                        <div className={"dfields"}>
                            <Controller
                                name="quater"
                                control={control}
                                rules={{ required:Required }}
                                render={({ field }) => (
                                    <SelectField
                                        showSearch={true}
                                        label={"Select Quarter"}
                                        field={field}
                                        placeholder={"Select Quarter"}
                                        className={"required"}
                                        options={quarterSelect}
                                        fieldName={field.name}
                                        value={field.value}
                                        setValue={setValue}
                                        errors={errors.quater}
                                    />
                                )}
                            />
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className={"dfields"}>
                            <Controller
                                name="month"
                                control={control}
                                rules={{ required:Required }}
                                render={({ field }) => (
                                    <SelectField
                                        showSearch={true}
                                        label={"Select Month"}
                                        field={field}
                                        value={field.value}
                                        placeholder={"Select Month"}
                                        className={"required"}
                                        options={monthOptions}
                                        fieldName={field.name}
                                        setValue={setValue}
                                        errors={errors.month}
                                    />
                                )}
                            />
                        </div>
                    </Col>                    {(selectedCategory === "" || duplicateData) && (
                        <Col md={12}>
                            <div className={"dfields"}>
                                <Controller
                                    name="category"
                                    control={control}
                                    defaultValue={duplicateData?.category || ""}
                                    rules={{ required:Required }}
                                    render={({ field }) => (
                                        <SelectField
                                            showSearch={true}
                                            label={"Select Category"}
                                            field={field}
                                            placeholder={"Select Category"}
                                            className={"required"}
                                            options={categorySelect}
                                            fieldName={field.name}
                                            setValue={setValue}
                                            errors={errors.category}
                                            value={duplicateData ? duplicateData.category : field.value}
                                        />
                                    )}
                                />
                            </div>
                        </Col>
                    )}
                    <Col md={12}>
                        <div className={'dfields'}>
                            <Controller
                                name="des"
                                defaultValue={''}
                                control={control}
                                rules={{required:Required, maxLength: maxLength(2000) , validate:checkEmptySpaces}}
                                render={({field: {name, ...field}}) => (
                                    <DescriptionField
                                        placeholder={'Write your monthly quest here'}
                                        type={'text'}
                                        defaultValue={field.value}
                                        field={field}
                                        errors={errors.des}
                                        autoSize={{ minRows: 1, maxRows: 1 }}
                                        label={'Write your Monthly Quest'}
                                    />
                                )}
                            />
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className={'mt-30'}>
                            <ThemeButton
                                text={'Add'}
                                type={'submit'}
                                className={'btn-light-lg'}
                                loader={loader}
                            />
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}